import React from 'react';

export const QuizContext = React.createContext({
    answer: null,
    setAnswer: (answer) => { },
    explanations: [],
    setExplanations: (explanation) => { },
    loading: null,
    setLoading: (loading) => { },
    fetched: null,
    setFetched: (fetched) => { },
});

const QuizProvider = ({ children }) => {
    const [answer, setAnswer] = React.useState(null);
    const [explanations, setExplanations] = React.useState([]);
    const [loading, setLoading] = React.useState(null);
    const [fetched, setFetched] = React.useState(null);

    return (
        <QuizContext.Provider value={{ answer, setAnswer, explanations, setExplanations, loading, setLoading, fetched, setFetched }}>
            {children}
        </QuizContext.Provider>
    );
};

export default QuizProvider;